import keyMirror from 'keymirror';

const SidebarTabConstants = keyMirror({
  GuestsTab: null,
  ServersTab: null,
});

export default SidebarTabConstants;
